<div class="cart reveal"> <!-- Ajout de la classe reveal ici -->
  <h2>Your Cart</h2>
  
  <div *ngIf="cartItems.length === 0">
    <p>Your cart is empty..</p>
  </div>

  <table *ngIf="cartItems.length > 0">
    <thead>
      <tr>
        <th>Product</th>
        <th>Image</th>
        <th>Unit Price</th>
        <th>Quantity</th>
        <th>Total</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let item of cartItems">
        <tr>
          <!-- Ajout de la classe reveal ici -->
          <td>{{ item.item }}</td>
          <td>
            <img *ngIf="item.imagePath" [src]="authService.getImageUrl(item.imagePath)" alt="{{ item.item }}" width="50" />
          </td>
          <td>{{ isEligibleForTotal(item.attribute) ? (item.price | currency) : '0' }}</td>
          <td>
            <input type="number" [value]="item.quantity" min="-10" (change)="onQuantityChange($event, item)" />
          </td>
          <td>{{ isEligibleForTotal(item.attribute) ? (item.totalAmt | currency) : '0' }}</td>
          <td>
            <button (click)="removeItem(item.attribute)">Remove</button>
          </td>
        </tr>
        <tr *ngIf="warningMessages[item.attribute]">
          <td colspan="6" class="warning">{{ warningMessages[item.attribute] }}</td>
        </tr>
      </ng-container>
    </tbody>
  </table>

  <div *ngIf="cartItems.length > 0" class="cart-summary">
    <p>Total items: {{ getTotalItemCount() }}</p>
    <p>
      Total amount: {{ getTotalAmount() | currency }}
    </p>
    <button *ngIf="hasActiveAddress" (click)="finalizeOrder()">Finalize the order</button>
    <button *ngIf="hasActiveAddress" [routerLink]="['/address']">My addresses</button>
    <button *ngIf="!hasActiveAddress" [routerLink]="['/address']">Add an address</button>

  </div>
</div>
